import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { RelationshipLogoLink } from './RelationshipLogoLink';
import styles from './AboutRelationship.scss';

interface AboutRelationshipProps {
  description?: string | null;
  landingPageUrl: string;
  logo?: string | null;
  name: string;
  parentName?: string | null;
  parentPageUrl?: string;
  inline?: boolean;
  logoVariant?: 'mini' | 'normal';
}

const AboutRelationship: FunctionComponent<AboutRelationshipProps> = ({
  children,
  description,
  landingPageUrl,
  logo,
  name,
  parentName,
  parentPageUrl,
  inline,
  logoVariant = 'mini',
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <section className={inline ? styles.aboutRelationship : ''}>
      {logo && (
        <RelationshipLogoLink
          name={name}
          pageUrl={landingPageUrl}
          qaIdentifier="owner-logo"
          itemProp="logo"
          logo={logo}
          variant={logoVariant}
        />
      )}
      <div>
        <h2 itemProp="name" className={inline ? styles.title : ''}>
          <a
            className={inline ? 'jg-h4' : 'jg-text--regular'}
            href={landingPageUrl}
            data-qa="relationship-name-link"
          >
            {name}
          </a>
          {parentName && (
            <div className="jg-h6" data-qa="parent-details">
              <span className="jg-text--light">
                {t('common.runby', 'run by ')}
              </span>
              <a className="jg-text--regular" href={parentPageUrl}>
                {parentName}
              </a>
            </div>
          )}
        </h2>
        {description && (
          <p
            itemProp="description"
            className={inline ? 'jg-space-mbmd' : 'jg-text--large'}
          >
            {description}
          </p>
        )}
        {children}
      </div>
    </section>
  );
};

export default AboutRelationship;
